import { AfterViewInit, Directive, ElementRef, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudItemComponent, UserStorage, requiredValidator } from '@scisys-uim/uim-common';
import { AssetsUser, BUSINESS_UNIT_EMAIL_CONTACT_TYPE, BUSINESS_UNIT_METADATA, BUSINESS_UNIT_TYPE, BusinessUnit, BusinessUnitEmailContact, RefCode, setDefaultLocationFromUser } from 'assets-model';
import { BusinessUnitEmailContactService, BusinessUnitService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class BusinessUnitEmailContactItemComponentBase extends CrudItemComponent<BusinessUnitEmailContact, number> implements OnInit, AfterViewInit {

  protected systemConfig: any;
  
  public form: FormGroup;
  
  businessUnitSelectionList: BusinessUnit[];

  addrTypeSelectionList: RefCode[];


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected businessUnitEmailContactService: BusinessUnitEmailContactService,
    protected businessUnitService: BusinessUnitService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(BUSINESS_UNIT_EMAIL_CONTACT_TYPE, fb, elementRef, router, route, userStorage, dialog, businessUnitEmailContactService, injector, snackbar);
  }

  createNewItem() {
    return new BusinessUnitEmailContact();
  }
  
  createForm(): FormGroup {
    return this.fb.group({
      businessUnitEmailContactId: [null, [requiredValidator,]],
      businessUnit: [null, []],
      addrType: [null, []],
      createdBy: [null, []],
      createdDate: [null, []],
      description: [null, []],
      email: [null, [requiredValidator,]],
      lockVersion: [null, []],
      updatedBy: [null, []],
      updatedDate: [null, []]
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }
  
  protected initSystemConfig(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initSystemConfig(config);
  }
  
  setDefaults() {
    if (!this.readOnly && this.createMode) {
      setDefaultLocationFromUser(this.userDetails, this.item);

      // re-trigger updating drop-downs.
      this.itemSet();
    }
    this.setDefaultDisabledFields();
  }

  setDefaultDisabledFields() {
    if (!this.form) {
      return;
    }
    if (!this.createMode) {
      this.businessUnitEmailContactId?.disable();
    }
  }
  
  businessUnitEmailContactIdChanging(value: number, unsetDependents: boolean = true) {}
  
  businessUnitEmailContactIdChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.businessUnitEmailContactIdChangedByUser(value, unsetDependents);
    }
  }  
  
  businessUnitEmailContactIdChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  
  businessUnitDisplay(item: BusinessUnit) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return BUSINESS_UNIT_TYPE.description(item);
  }
  
  businessUnitLoadSelectionList() {
    this.businessUnitService.findAll().subscribe(
      data => {
        this.businessUnitSelectionList = BUSINESS_UNIT_TYPE.entityDecorator.ensureContained(this.item && this.item.businessUnit, data.items);
      }
    );
  }

  businessUnitChanging(value: BusinessUnit, unsetDependents: boolean = true) {}
  
  businessUnitChanged(value: BusinessUnit, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.businessUnitChangedByUser(value, unsetDependents);
    }
  }  
  
  businessUnitChangedByUser(value: BusinessUnit, unsetDependents: boolean = true) {
  }
  
  businessUnitCompare(a: any, b: any) {
    return BUSINESS_UNIT_METADATA.equals(a, b);
  }
  
  addrTypeLoadSelectionList() {
    this.refCodeStorage.getDomainElements('BU_ADDR_TYPE').subscribe(
      data => {
        this.addrTypeSelectionList = data;
      }
    );
  }

  addrTypeChanging(value: string, unsetDependents: boolean = true) {}
  
  addrTypeChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.addrTypeChangedByUser(value, unsetDependents);
    }
  }  
  
  addrTypeChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  createdByChanging(value: string, unsetDependents: boolean = true) {}
  
  createdByChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.createdByChangedByUser(value, unsetDependents);
    }
  }  
  
  createdByChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  createdDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateChanged(value: Date, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.createdDateChangedByUser(value, unsetDependents);
    }
  }  
  
  createdDateChangedByUser(value: Date, unsetDependents: boolean = true) {
  }
  
  descriptionChanging(value: string, unsetDependents: boolean = true) {}
  
  descriptionChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.descriptionChangedByUser(value, unsetDependents);
    }
  }  
  
  descriptionChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  emailChanging(value: string, unsetDependents: boolean = true) {}
  
  emailChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.emailChangedByUser(value, unsetDependents);
    }
  }  
  
  emailChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  lockVersionChanging(value: number, unsetDependents: boolean = true) {}
  
  lockVersionChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.lockVersionChangedByUser(value, unsetDependents);
    }
  }  
  
  lockVersionChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  
  updatedByChanging(value: string, unsetDependents: boolean = true) {}
  
  updatedByChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.updatedByChangedByUser(value, unsetDependents);
    }
  }  
  
  updatedByChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  updatedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateChanged(value: Date, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.updatedDateChangedByUser(value, unsetDependents);
    }
  }  
  
  updatedDateChangedByUser(value: Date, unsetDependents: boolean = true) {
  }
  

  control(name: string) {
    return this.form ? this.form.get(name) : null;
  }

  get businessUnitEmailContactId() {
    return this.control('businessUnitEmailContactId');
  }
  
  get businessUnit() {
    return this.control('businessUnit');
  }
  
  get addrType() {
    return this.control('addrType');
  }
  
  get createdBy() {
    return this.control('createdBy');
  }
  
  get createdDate() {
    return this.control('createdDate');
  }
  
  get description() {
    return this.control('description');
  }
  
  get email() {
    return this.control('email');
  }
  
  get lockVersion() {
    return this.control('lockVersion');
  }
  
  get updatedBy() {
    return this.control('updatedBy');
  }
  
  get updatedDate() {
    return this.control('updatedDate');
  }
  
}





